import type { SVGProps } from 'react'
const LineSupport = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			d="M20.845 7.34c.29-.48.23-1.11-.185-1.525L18.185 3.34a1.25 1.25 0 0 0-1.525-.185 9.95 9.95 0 0 0-9.32 0c-.48-.29-1.11-.23-1.525.185L3.34 5.815a1.25 1.25 0 0 0-.185 1.525 9.95 9.95 0 0 0 0 9.32c-.29.48-.23 1.11.185 1.525l2.475 2.475a1.245 1.245 0 0 0 1.525.185c1.46.77 3.06 1.16 4.66 1.16s3.2-.39 4.66-1.16a1.245 1.245 0 0 0 1.525-.185l2.475-2.475c.415-.415.47-1.045.185-1.525a9.95 9.95 0 0 0 0-9.32m-3.47 5.795c.155-.75.155-1.52 0-2.27L19.74 8.5a8.48 8.48 0 0 1 0 7.005l-2.365-2.365zm2.05-6.435L16.8 9.325a5.3 5.3 0 0 0-.91-1.21c-.37-.365-.78-.67-1.21-.91l2.625-2.625zM9.17 14.83a4 4 0 0 1 0-5.655A4 4 0 0 1 12 8.005c1.025 0 2.05.39 2.83 1.17a4 4 0 0 1 0 5.655c-1.56 1.555-4.1 1.56-5.655 0zM15.5 4.255l-2.37 2.37a5.6 5.6 0 0 0-2.27 0L8.495 4.26a8.48 8.48 0 0 1 7.005 0zm-8.805.32L9.32 7.2c-.435.24-.845.54-1.21.91s-.67.78-.91 1.21L4.575 6.695zM4.255 15.5a8.48 8.48 0 0 1 0-7.005l2.37 2.37a5.6 5.6 0 0 0 0 2.27l-2.37 2.37zm.32 1.8L7.2 14.675c.24.435.54.845.91 1.21s.78.67 1.21.91L6.695 19.42zM8.5 19.74l2.37-2.37a5.4 5.4 0 0 0 2.27 0l2.37 2.37a8.48 8.48 0 0 1-7.005 0zm8.805-.32-2.625-2.625c.435-.24.845-.54 1.21-.91s.67-.78.91-1.21l2.625 2.625z"
		/>
	</svg>
)
export { LineSupport }
